import { render, staticRenderFns } from "./MatchHoldExpiredStep.vue?vue&type=template&id=f739f48c"
import script from "./MatchHoldExpiredStep.vue?vue&type=script&lang=js"
export * from "./MatchHoldExpiredStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports